import React, { Component } from "react";
import { Grid, Row, Col } from "react-flexbox-grid";

export default class Terms extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div style={{ maxWidth: 600, margin: "5% auto",}}>
        <Grid>
          <Row center="xs">
            <Col xs={10} md={12} className="long-text">
              <h1 lg bold accent>
                Terms of Use
              </h1>
              <p>
                By accessing the website at{" "}
                <a href="http://Lynkone.me & Lynkone App">http://lynkone.me & Lynkone App</a>, you are
                agreeing to be bound by these terms of service, all applicable
                laws and regulations, and agree that you are responsible for
                compliance with any applicable local laws. If you do not agree
                with any of these terms, you are prohibited from using or
                accessing this site. The portfolios contained in this website
                are protected by applicable copyright and trademark law.
              </p>
              <h2>Use License</h2>
              <ul>
                <li>
                  Permission is granted to temporarily download one copy of the
                  portfolios (information or software) on Lynkone.me & Lynkone App's website for
                  personal, non-commercial transitory viewing only. This is the
                  grant of a license, not a transfer of title, and under this
                  license you may not:
                  <ol type="i">
                    <li>modify or copy the portfolios;</li>
                    <li>
                      use the portfolios for any commercial purpose, or for any
                      public display (commercial or non-commercial);
                    </li>
                    <li>
                      attempt to decompile or reverse engineer any software
                      contained on Lynkone.me & Lynkone App's website;
                    </li>
                    <li>
                      remove any copyright or other proprietary notations from
                      the portfolios; or
                    </li>
                    <li>
                      transfer the portfolios to another person or "mirror" the
                      portfolios on any other server.
                    </li>
                  </ol>
                </li>
                <li>
                  This license shall automatically terminate if you violate any
                  of these restrictions and may be terminated by Lynkone.me & Lynkone App at any
                  time. Upon terminating your viewing of these portfolios or
                  upon the termination of this license, you must destroy any
                  downloaded portfolios in your possession whether in electronic
                  or printed format.
                </li>
              </ul>
              <h2>Disclaimer</h2>
              <ul>
                <li>
                  The portfolios on Lynkone.me & Lynkone App's website are provided on an 'as is'
                  basis by the users. Lynkone.me & Lynkone App makes no warranties, expressed or
                  implied, and hereby disclaims and negates all other warranties
                  including, without limitation, implied warranties or
                  conditions of merchantability, fitness for a particular
                  purpose, or non-infringement of intellectual property or other
                  violation of rights.
                </li>
              </ul>
              <h2>Accuracy of portfolios</h2>
              <p>
                The portfolios appearing on Lynkone.me & Lynkone App's website could include
                technical, typographical, or photographic errors. Lynkone.me & Lynkone App does
                not warrant that any of the portfolios on its website are
                accurate, complete or current. Lynkone.me & Lynkone App may make changes to the
                portfolios contained on its website at any time without notice.
                However Lynkone.me & Lynkone App does not make any commitment to update the
                portfolios.
              </p>
              <h2>Links</h2>
              <p>
                Lynkone.me & Lynkone App has not reviewed all of the sites linked to its website
                and is not responsible for the contents of any such linked site.
                The inclusion of any link does not imply endorsement by Lynkone.me & Lynkone App
                of the site. Use of any such linked website is at the user's own
                risk.
              </p>
              <h2>Modifications</h2>
              <p>
                Lynkone.me & Lynkone App may revise these terms of service for its website at any
                time without notice. By using this website you are agreeing to
                be bound by the then current version of these terms of service.
              </p>
              <h2>Governing Law</h2>
              <p>
                These terms and conditions are governed by and construed in
                accordance with the laws of India and you irrevocably submit to
                the exclusive jurisdiction of the courts in that State or
                location.
              </p>
            </Col>
          </Row>
        </Grid>

      </div>
    );
  }
}
